export default __webpack_public_path__ + "static/media/calendar_empty.06671887.svg";